<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item ref="name" label="收货人" name="name">
              <a-input v-model:value="form.name" placeholder='请输入收货人' />
        </a-form-item>
        <a-form-item ref="phone" label="手机号" name="phone">
              <a-input v-model:value="form.phone" placeholder='请输入手机号' />
        </a-form-item>
        <a-form-item ref="addressList" label="退换货收货地址" name="addressList">
          <a-cascader
            v-model:value="form.addressList"
            :field-names="{ label: 'name', value: 'id', children: 'children' }"
            :options="cityList"
            placeholder="请选择收货地址"
            @change="onChangeAddress"
          />
        </a-form-item>
        <a-form-item ref="address" label="详细地址" name="address">
          <a-input v-model:value="form.address" placeholder='请输入详细地址' />
        </a-form-item>
        <a-form-item ref="remark" label="备注" name="remark" >
          <a-row :gutter="16">
            <a-col :span="16">
              <a-textarea v-model:value="form.remark" showCount :maxlength="200" placeholder="请输入备注" :rows="4" />
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 8, offset: 4 }">
          <a-checkbox v-model:checked="form.is_default">
            是否为默认地址
          </a-checkbox>
        </a-form-item>
        
        <a-form-item :wrapper-col="{ span: 8, offset: 4 }">
          <a-button type="primary" @click="onSubmit">
            保存
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
</template>
<script>
  import { ref, onMounted, reactive, toRefs, inject,watchEffect } from 'vue';
  import { message } from 'ant-design-vue';
  import { getArea } from "@/api/public";
  import { getAddressMore } from "@/api/order";
  import { iscode } from "@/utils/app";
  // 初始化默认筛选项数值
  let defForm = {
    province_id: '',
    city_id: '',
    county_id: '',
    address: '',
    name:'',
    phone:'',
    remark:'',
    is_default:0
  }
  export default {
    name:'addressAdd',
    props: {
      formData: {
        type: Object
      },
    },
    components: {
      
    },
    setup(props,{emit}) {
      //pass
      const form = ref({ ...defForm });
      const state = reactive({
        cityList:[],
        address:[],
        loading: false,
        labelCol: { span: 4 },
        wrapperCol: { span: 16 },
        rules: {
          name: [
            { required: true, message: '请输入收货人姓名'},
          ],
          phone: [
            { required: true, message: '请输入收货人姓名'},
          ],
          addressList: [
            { required: true, message: '请选择收货地址'},
          ],
          address: [
            { required: true, message: '请输入详细地址'},
          ],
        }
      });
      const ruleForm = ref()
      const $route = inject('$route')
      const $Modal = inject('$Modal')
      const $router = inject('$router')
      //获取省市区
      const getAreaList = async () => {
        let result = await getArea().then(res => res)
        state.cityList = result.data
      }
      getAreaList();
      //选择省市区
      const onChangeAddress = (e) => {
        form.value.province_id = e[0]
        form.value.city_id = e[1]
        form.value.county_id = e[2]
      }
      const getMore = async() =>{
        let res = await getAddressMore({id:props.formData.id}).then(res => res.data);
        if (iscode(res)) {
          form.value = res.data;
          form.value.addressList = [res.data.province_id,res.data.city_id,res.data.county_id]
        } else {
          message.error(res.msg);
        }
      }
      const onSubmit = () => {
        ruleForm.value.validate().then(() => {
          emit('onsubmit',form.value)
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      watchEffect(() => {
        if(props.formData.id){
          getMore();
        }
      });
      return {
        form,
        ...toRefs(state),
        ruleForm,
        onSubmit,
        onChangeAddress
      }
    }
  }
</script>